module.exports = __webpack_public_path__ + "img/xiangmu1.8a129a06.png";